import { render, staticRenderFns } from "./ProductPopularity.vue?vue&type=template&id=4430e504&scoped=true"
import script from "./ProductPopularity.vue?vue&type=script&lang=js"
export * from "./ProductPopularity.vue?vue&type=script&lang=js"
import style0 from "./ProductPopularity.vue?vue&type=style&index=0&id=4430e504&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430e504",
  null
  
)

export default component.exports